import router from '../router'
import wx from 'weixin-js-sdk'
import { getWxConfig } from '@/api/wx'

function onBridgeReady (data) {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest', {
      'appId': data.appId, // 公众号名称，由商户传入
      'timeStamp': data.timeStamp, // 时间戳，自1970年以来的秒数
      'nonceStr': data.nonceStr, // 随机串
      'package': data.package,
      'signType': data.signType, // 微信签名方式
      'paySign': data.paySign // 微信签名
    },
    async function (res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        if (data.order_type === 'race') {
          router.replace({ name: 'myrace' })
        } else {
          router.replace({ name: 'home' })
        }
      } else {
        router.replace({ name: 'orderdetail', params: { order_no: data.order_no } })
      }
    }
  )
}

export function callPay (data) {
  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady(data)
  }
}

// 获取微信配置信息的接口
// 1，在公众号菜单中的链接打开，才能正常分享卡片；
// 2，可以通过收藏链接，再打开分享也是卡片；
// 3，把链接换成二维码，扫码后进入分享也是卡片。
// 所有的前提是你配置必须OK！如果是用微信直接打开链接分享会是链接。
export async function wxShare (title, desc, link, imgUrl) {
  const url = location.href.split('#')[0]
  title = '365一起跑'
  desc = '365一起跑'
  link = `${location.protocol}//${location.host}${process.env.VUE_APP_ROUTER_BASE}explore`
  imgUrl = 'http://running-upload.oss-cn-hangzhou.aliyuncs.com/logo.jpg'

  const response = await getWxConfig({
    url
  })

  wx.config({
    debug: false,
    appId: response.data.appId,
    timestamp: response.data.timestamp,
    nonceStr: response.data.nonceStr,
    signature: response.data.signature,
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
  })

  wx.ready(function () {
    wx.updateAppMessageShareData({
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl, // 分享图标
      success: function () {
        // 设置成功
      }
    })

    wx.updateTimelineShareData({
      title, // 分享标题
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl, // 分享图标
      success: function () {
        // 设置成功
      }
    })
  })
}
